import { render } from "./EllipsisMiddleText.vue?vue&type=template&id=28f2709c"
import script from "./EllipsisMiddleText.vue?vue&type=script&lang=js"
export * from "./EllipsisMiddleText.vue?vue&type=script&lang=js"
script.render = render

export default script